<template>
  <v-row justify="center">
    <v-dialog v-model="shower" scrollable persistent max-width="1200px">
      <v-card>
        <v-divider></v-divider>
        <v-card-text style="height:800px">
          <v-layout row wrap class="pa-2">
            <v-flex xs12 lg12>
              <v-overlay :value="loadprogress" absolute :color="color.BG" dark>
                <v-progress-circular
                  indeterminate
                  size="64"
                  :color="color.theme"
                ></v-progress-circular>
              </v-overlay>
              <br />
              <v-list nav>
                <v-list-item class="text-left">
                  <v-list-item-avatar class="text-center">
                    <v-avatar :color="color.theme" size="35">
                      <v-icon dark size="20">mdi-account-multiple</v-icon>
                    </v-avatar>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>
                      <span :style="headerPage"
                        >&nbsp;{{ $t("admintoolbar.dataemployee") }}  &nbsp; Group &nbsp; {{ data_group.group_name }}</span
                      >
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-layout>
                <v-flex lg2 md4 xs9 class="mr-2">
                  <v-text-field
                    v-model="search_employee"
                    class="pl-1"
                    :label="$t('admin.search')"
                    clearable
                    outlined
                    dense
                    :color="color.theme"
                    append-icon="search"
                    @click:clear="(search_employee = ''), fn_load_employee()"
                  ></v-text-field>
                </v-flex>
                <v-flex lg1 xs2 class="pl-1">
                  <v-btn
                    :color="color.theme"
                    :dark="color.darkTheme"
                    @click="fn_load_employee(search_employee)"
                    >{{ $t("admin.search") }}</v-btn
                  >
                </v-flex>
              </v-layout>
              <v-layout row wrap class="pl-3 pr-3">
                      <v-flex lg8 md8 xs8 class="mr-2">
                        <v-chip
                          class="ma-2"
                          :color="color.theme"
                          :text-color="color.chipText"
                        >
                          <v-icon left>mdi-account-group</v-icon>
                          {{ count_data_folder }}
                        {{$t("group_.user")}}
                        </v-chip>
                      </v-flex>
                      <v-spacer></v-spacer>
                      <v-flex lg3 md3 xs3 class="text-right">
                        <v-btn :color="color.theme" :dark="color.darkTheme" @click="fn_Add_employee()">{{
                          $t("admintoolbar.addemployee")
                        }}</v-btn>
                      </v-flex>

                    </v-layout>
              <div v-if="loaddataprogresstable === true">
                <v-flex lg12 class="ma-2 ml-4 mr-4">
                  <div class="text-center">
                    <!-- <v-progress-circular :size="50" :color="color.theme" indeterminate></v-progress-circular> -->
                    <v-skeleton-loader
                      class="mx-auto"
                      type="table"
                    ></v-skeleton-loader>
                  </div>
                </v-flex>
              </div>
              <div v-else>
                <div v-if="resolutionScreen >= 500">
                  <v-data-table
                    :headers="$t('default') === 'en' ? headers_eng : headers_th"
                    :items="data_em"
                    item-key="account_id"
                    :single-select="false"
                    class="elevation-0"
                    item-selected
                    :page.sync="page"
                    :items-per-page="size"
                    :hide-default-footer="true"
                    @page-count="pageCount = $event"
                    :no-data-text="$t('tablefile.empty')"
                  >
                    <template v-slot:[`header.account_id`]="{ header }">
                      <span :style="headerTable">{{ header.text }}</span>
                    </template>
                    <template v-slot:[`header.first_name_eng`]="{ header }">
                      <span class="pointer" :style="headerTable">{{
                        $t(header.text)
                      }}</span>
                    </template>
                    <template v-slot:[`header.mobile`]="{ header }">
                      <span class="pointer" :style="headerTable">{{
                        $t(header.text)
                      }}</span>
                    </template>
                    <template v-slot:[`header.email`]="{ header }">
                      <span class="pointer" :style="headerTable">{{
                        $t(header.text)
                      }}</span>
                    </template>
                    <template v-slot:[`header.user_id`]="{ header }">
                    <span :style="headerTable">{{ $t(header.text) }}</span>
                  </template>
    
                    <template v-slot:item="props">
                      <tr
                        style="cursor: pointer"
                      >
                        <td width="7%" class="text-center">
                          <v-icon
                            v-if="props.item.status_admin === true"
                            :color="color.theme"
                            >mdi-account-star</v-icon
                          >
                          <v-icon v-else>mdi-account</v-icon>
                        </td>
                        <td width="30%" v-if="$t('default') === 'th'">
                          {{
                            props.item.first_name_th +
                              " " +
                              props.item.last_name_th
                          }}
                        </td>
                        <td width="30%" v-else>
                          {{
                            props.item.first_name_eng +
                              " " +
                              props.item.last_name_eng
                          }}
                        </td>
                        <td width="15%">{{ props.item.mobile }}</td>
                        <td width="15%">{{ props.item.email }}</td>
                        <td width="10%" class="text-center">
                            <v-menu>
                              <template v-slot:activator="{ attrs, on }">
                                <v-btn class="elevation-0" fab small v-bind="attrs" v-on="on">
                                  <v-icon>settings</v-icon>
                                </v-btn>
                              </template>
                              <v-list>
                                <v-list-item link @click="fn_deleteingroup(props.item)">
                                  <v-list-item-icon>
                                    <v-icon>mdi-account-minus</v-icon>
                                  </v-list-item-icon>
                                  <v-list-item-content>
                                    <v-list-item-title>{{ $t("group_.delete_user_ingroup") }}</v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </td>
                      </tr>
                    </template>
                  </v-data-table>
                </div>
                <div v-else>
                  <v-list
                    two-line
                    class="mb-6 pb-6 elevation-0"
                    v-if="this.count_data_folder !== 0"
                  >
                    <v-list-item
                      v-for="item in data_em"
                      :key="item.title"
                      style="cursor: pointer;"
                    >
                      <v-list-item-action>
                        <v-icon large>mdi-account</v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title
                          v-if="$t('default') === 'th'"
                          v-text="item.first_name_th + ' ' + item.last_name_th"
                        ></v-list-item-title>
                        <v-list-item-title
                         v-else
                          v-text="item.first_name_eng + ' ' + item.last_name_eng"
                        ></v-list-item-title>
                        <v-list-item-subtitle
                          v-text="item.email"
                        ></v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                  <v-list v-else class="mb-6 pb-6 elevation-0">
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          class="text-center"
                          v-text="$t('tablefile.empty')"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </div>
              </div>
              <v-layout row wrap justify-center>
                <v-flex xs11 lg11 v-if="pageCount > 0">
                  <v-pagination
                    :total-visible="10"
                    v-model="page"
                    :length="pageCount || 0"
                    :color="color.theme"
                    @input="clickpagination()"
                  ></v-pagination>
                </v-flex>
              </v-layout>
              <v-card-text> </v-card-text>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red" outlined @click="closeadminmydrive()">{{
            $t("admin.close")
          }}</v-btn>
        </v-card-actions>
        <dialogaddemployeeeingroup
          :show="opendialogaddemployeeingroup"
          @close="opendialogaddemployeeingroup = false"
          @reload="opendialogaddemployeeingroup = false ,fn_load_employee() "
          :data_group="data"
        ></dialogaddemployeeeingroup>
        <dialogdeleteemployeeeingroup
          :show="opendialogdeleteemployeeeingroup"
          @close="opendialogdeleteemployeeeingroup = false"
          @reload="opendialogdeleteemployeeeingroup = false ,fn_load_employee() "
          :data_group="data"
          :data_user="data_user"
        ></dialogdeleteemployeeeingroup>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapState, mapGetters } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
import { validationMixin } from "vuelidate";
import { required, maxLength, email } from "vuelidate/lib/validators";
import gbfGenerate from "@/globalFunctions/generateAuthorize";
import gbfdecodearraybuffer from "@/globalFunctions/decodearraybuffer";
import gb_sizeDataConverter from "@/globalFunctions/sizeDataConverter";
const dialogaddemployeeeingroup = () => import("@/components/optional/dialog-addemployeeingroup");
const dialogdeleteemployeeeingroup = () => import("@/components/optional/dialog-comfirmdeleteemployeeingroup");



const Toast = Swal.mixin({
  toast: true,
  position: "top-end",
  showConfirmButton: false,
  timer: 3000,
});

export default {
  mixins: [validationMixin],
  validations: {
    filename: { required },
  },
  props: ["show", "data_group"],
  components: {
    dialogaddemployeeeingroup,
    dialogdeleteemployeeeingroup
  },
  data: function() {
    return {
      data_user:{},
      opendialogdeleteemployeeeingroup:false,
      data:{},
      opendialogaddemployeeingroup:false,
      search_employee:"",
      parentfolder: "",
      currentfile: {},
      openpreviewfile: false,
      navigate: [],
      file: {},
      percent: 0,
      datetime: "",
      opensnackbardownloadfile: false,
      opensnackbarmultidownload: false,
      opensnackbar: false,
      newpercen: [],
      namefile: "",
      new_list: [],
      newlist: [],
      dataIndex: "",
      datadowload: {},
      listdatadowload: [],
      listdowload: [],
      listdatadowload: [],
      newlist: [],
      btsdownload: false,
      percentCompleted: 0,
      count_data_folder: 0,
      size: 20,
      page: 1,
      data_em: [],
      headers_eng: [
        {
          text: "#",
          align: "center",
          value: "c",
          width: "7%",
          sortable: false,
        },
        {
          text: "tablefile.name",
          value: "first_name_eng",
          width: "30%",
          align: "left",
          sortable: false,
        },
        {
          text: "tablefile.tel",
          value: "mobile",
          width: "15%",
          align: "left",
          sortable: false,
        },
        {
          text: "tablefile.email",
          value: "email",
          width: "15%",
          align: "center",
          sortable: false,
        },
        {
            text: "addemployee.setting",
            value: "user_id",
            width: "15%",
            align: "center",
            sortable: false,
          },
      ],
      headers_th: [
        {
          text: "#",
          align: "center",
          value: "account_id",
          width: "7%",
          sortable: false,
        },
        {
          text: "tablefile.name",
          value: "first_name_eng",
          width: "30%",
          align: "left",
          sortable: false,
        },
        {
          text: "tablefile.tel",
          value: "mobile",
          width: "15%",
          align: "left",
          sortable: false,
        },
        {
          text: "tablefile.email",
          value: "email",
          width: "15%",
          align: "center",
          sortable: false,
        },
        {
            text: "addemployee.setting",
            value: "user_id",
            width: "15%",
            align: "center",
            sortable: false,
          },
      ],
      SWmydrive: false,
      SWmyinbox: false,
      SWmyoutbox: false,
      SWshare: false,
      SWtrash: false,
      SWstared: false,
      createprogress: false,
      nametitle: "",
      selectall: false,
      switchfeature: "",
      feature: [],
      selected: [],
      test: 1,
      loadprogress: false,
      loaddataprogresstable: false,
    };
  },
  computed: {
    ...mapState([
      "username",
      "authorize",
      "account_active",
      "color",
      "role_level",
    ]),
    ...mapState({ processloader: "loading" }),
    ...mapGetters([
      "dataUsername",
      "dataAuthorize",
      "dataAccountActive",
      "dataAccesstoken",
      "dataBusinessProfile",
      "dataCitizenProfile",
      "dataDepartmentAccessId",
      "dataAccountId",
    ]),
    resolutionScreen() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return 220;
        case "sm":
          return 400;
        case "md":
          return 500;
        case "lg":
          return 600;
        case "xl":
          return 800;
      }
    },
    shower: {
      get() {
        if (this.show === true) {
          console.log(this.data_group);
          this.fn_load_employee();
 
        }
        return this.show;
      },
      // set(value) {
      //   if (!value) {
      //     this.selected = [];
      //   }
      // },
    },
    pageCount: {
      get() {
        let l = this.count_data_folder;
        let s = this.size;
        console.log("Math.ceil(l / s);", Math.ceil(l / s));
        return Math.ceil(l / s);
      },
      set(newName) {
        return newName;
      },
    },
    colorProgress() {
      return "color:" + this.color.theme + ";";
    },
    headerTable() {
      return (
        "color:" + this.color.theme + ";" + "font-weight: 600; font-size:15px;"
      );
    },
    headerPage() {
      // console.log(this.color.theme);

      return (
        "color:" + this.color.theme + ";" + "font-size: 18px; font-weight: 600;"
      );
    },
  },

  methods: {
    fn_deleteingroup(item){
      console.log("item",item);
      
      this.opendialogdeleteemployeeeingroup = true;
      this.data = this.data_group;
      this.data_user = item;
    },
    fn_Add_employee(){
      this.opendialogaddemployeeingroup = true;
      this.data = this.data_group;
    },
    formatdatetime(_datetime) {
      if (
        _datetime === "" ||
        _datetime === "-" ||
        _datetime === undefined ||
        _datetime === null
      ) {
        return "-";
      } else {
        let dateyear =
          _datetime.split("")[0] +
          _datetime.split("")[1] +
          _datetime.split("")[2] +
          _datetime.split("")[3];
        let datemonth = _datetime.split("")[4] + _datetime.split("")[5];
        let dateday = _datetime.split("")[6] + _datetime.split("")[7];
        let hour = _datetime.split("")[8] + _datetime.split("")[9];
        let minute = _datetime.split("")[10] + _datetime.split("")[11];
        let second = _datetime.split("")[12] + _datetime.split("")[13];

        return (
          dateday +
          "/" +
          datemonth +
          "/" +
          dateyear +
          " " +
          hour +
          ":" +
          minute +
          ":" +
          second
        );
      }
    },
    clickpagination() {
      this.data_em = [];
      this.fn_load_employee();
    },
    async fn_load_employee(search_employee) {
      this.loaddataprogresstable = true;
      this.data_em = [];
      let cal_limit = this.size;
      let cal_offset = this.size * (this.page - 1);
      console.log(this.data_group);
      var payload = {
        group_id: this.data_group.id,
        search: search_employee,
        limit: cal_limit,
        offset: cal_offset,
      };
      let auth = await gbfGenerate.generateToken();
      this.axios
        // .post(process.env.VUE_APP_SERVICE_ADMIN + "/admin/api/select_files_and_folder_employee", payload, {
        .post(
          " https://f9300388b7d4.ngrok-free.app/api/admin/get_user_in_group",
          payload,
          {
            headers: { Authorization: auth.code },
          }
        )
        .then((response) => {
          console.log(response);
          if (response.data.status === "OK") {
            this.loaddataprogresstable = false;
            this.count_data_folder = response.data.total;
            for (let i = 0; i < response.data.list_group_business.length; i++) {
              let dataemployee = {};
              dataemployee["account_id"] =
                response.data.list_group_business[i]["account_id"];
              dataemployee["business_email_user"] =
                response.data.list_group_business[i]["business_email_user"];
              dataemployee["email"] =
                response.data.list_group_business[i]["email"];
              dataemployee["first_name_eng"] =
                response.data.list_group_business[i]["first_name_eng"];
              dataemployee["first_name_th"] =
                response.data.list_group_business[i]["first_name_th"];
              dataemployee["group_id"] =
                response.data.list_group_business[i]["group_id"];
              dataemployee["last_name_eng"] =
                response.data.list_group_business[i]["last_name_eng"];
              dataemployee["last_name_th"] =
                response.data.list_group_business[i]["last_name_th"];
              dataemployee["mobile"] =
                response.data.list_group_business[i]["mobile"];
              dataemployee["oneid_user_id"] =
                response.data.list_group_business[i]["oneid_user_id"];
              dataemployee["thai_email"] =
                response.data.list_group_business[i]["thai_email"];
              dataemployee["user_id"] =
                response.data.list_group_business[i]["user_id"];
              dataemployee["username"] =
                response.data.list_group_business[i]["username"];
              this.data_em.push(dataemployee);
            }
            console.log("this.data_em", this.data_em);
          } else {
            Toast.fire({
              icon: "error",
              title: response.data.status + ": " + response.data.errorMessage,
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.loaddataprogresstable = false;

          Toast.fire({
            icon: "error",
            title: "ไม่สามารถเชื่อมต่อไปที่ ONE-BOX ได้ในขณะนี้",
          });
        });
    },
    closeadminmydrive(){
      this.$emit('close');
    }






  },
};
</script>
<style></style>
